/* eslint-disable prefer-promise-reject-errors */
import { axios } from '@carvana/purchase-utils';

export const fetchContracts = (withCache = false) => {
  return axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/contracts/getcontracts?cache=${withCache}`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));
};

export const downloadContracts = async docuSignEnvelopeId =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/contracts/downloadcontracts/${docuSignEnvelopeId}`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));

export const fetchOrderOptions = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/order/availableoptions`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));

export const sendCoBuyerEmail = () =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/contracts/SendEmail?forPrimary=false`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));
